import { getCurrentUserDetail } from "@payping/redux/actions";
import { Layout } from "@payping/web-components";
import classNames from "classnames";
import React, { useEffect } from "react";
import { useAsync } from "react-use";
import { Outlet } from "react-router-dom";
import DashboardTools from "@/components/DashboardTools";
import { useAppDispatch, useAppSelector } from "@/utils/redux";
import { useHantanaConfig } from "@/utils/useHantanaConfig";

import styles from "../assets/scss/Main.module.scss";
import AppMainNav from "../components/AppMainNav";
import { LANGUAGES } from "@payping/utilities-shared/consts";

import { dashboardPreferencesAtom } from "@/core/state";
import { selectAtom } from "jotai/utils";
import { useAtom } from "jotai";

const languageAtom = selectAtom(dashboardPreferencesAtom, (val) => val.language);

const Main: React.FC = () => {
  const [language] = useAtom(languageAtom);
  const userId = useAppSelector((state) => state.user.personalInfo?.id);
  const dispatch = useAppDispatch();
  useAsync(() => dispatch(getCurrentUserDetail()), [dispatch]);
  useHantanaConfig();

  useEffect(() => {
    if (userId && window.gtag) {
      window.gtag?.("config", "G-LJZ799Y460", {
        user_id: userId,
      });
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [userId, window.gtag]);

  return (
    <Layout
      data-userid={userId}
      className={classNames(styles.container, language === LANGUAGES.ENGLISH ? "en-font" : "")}
    >
      {/* TODO MAKE IT FAR BETTER LATER , BE CONTENT WITH THIS FOR NOW */}
      <Layout.Content style={{ paddingBottom: "100px" }}>
        <AppMainNav />
        {/* //TODO check for lazy load later */}
        <Outlet />
        {/* <DetectMobileView mobile={<TOTPDrawer />} desktop={<TOTPModal />} /> */}
        <DashboardTools />
      </Layout.Content>
    </Layout>
  );
};

export default Main;
